/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Audio_BlockedInputs */

const th_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบราว์เซอร์หยุดเสียงไว้ เปิดเสียงเพื่อดำเนินการต่อ`)
};

const en_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your browser paused sound. Enable sound to continue.`)
};

const ja_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザーが音声を停止しました。音声を有効にしてください。`)
};

const zh_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的浏览器暂停了声音。取消静音即可继续。`)
};

const es_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu navegador ha pausado el sonido. Actívalo para continuar.`)
};

const pt_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu navegador pausou o som. Ative o som para continuar.`)
};

const id_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peramban Anda menjeda suara. Nyalakan suara untuk melanjutkan.`)
};

const fr_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre navigateur a coupé le son. Activez-le pour continuer.`)
};

const tl_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihininto ng browser mo ang tunog. I-unmute para magpatuloy.`)
};

const vi_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt của bạn đã tạm dừng âm thanh. Bật tiếng để tiếp tục.`)
};

const ko_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저가 소리를 멈췄습니다. 계속하려면 음소거를 해제하세요.`)
};

const de_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Browser hat den Ton angehalten. Schalte den Ton ein, um fortzufahren.`)
};

const ru_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Браузер приостановил звук. Включите звук, чтобы продолжить.`)
};

const tr_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcınız sesi durdurdu. Devam etmek için sesi açın.`)
};

const it_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il browser ha messo in pausa l'audio. Riattivalo per continuare.`)
};

const pl_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądarka wstrzymała dźwięk. Wyłącz wyciszenie, aby kontynuować.`)
};

const uk_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Браузер зупинив звук. Увімкніть звук, щоб продовжити.`)
};

const hi_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके ब्राउज़र ने ध्वनि रोक दी। जारी रखने के लिए ध्वनि चालू करें।`)
};

const ar_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوقف متصفحك الصوت. ألغِ الكتم للمتابعة.`)
};

const ms_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayar anda menjeda bunyi. Nyahsenyap untuk meneruskan.`)
};

const bn_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ব্রাউজার শব্দ থামিয়েছে। চালিয়ে যেতে শব্দ চালু করুন।`)
};

const zh_tw2_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的瀏覽器暫停了聲音。取消靜音即可繼續。`)
};

const zh_hk2_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的瀏覽器暫停了聲音。取消靜音即可繼續。`)
};

const ur_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کے براؤزر نے آواز روک دی۔ جاری رکھنے کے لیے آواز چالو کریں۔`)
};

const fa_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرورگرتان صدا را متوقف کرد. برای ادامه صدا را روشن کنید.`)
};

const sw_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kivinjari chako kimesimamisha sauti. Washa sauti ili kuendelea.`)
};

const nl_video_audio_blocked = /** @type {(inputs: Video_Audio_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je browser heeft het geluid stilgezet. Zet het geluid aan om verder te gaan.`)
};

/**
* | output |
* | --- |
* | "Your browser paused sound. Enable sound to continue." |
*
* @param {Video_Audio_BlockedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_audio_blocked = /** @type {((inputs?: Video_Audio_BlockedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Audio_BlockedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_audio_blocked(inputs)
	if (locale === "ja") return ja_video_audio_blocked(inputs)
	if (locale === "zh") return zh_video_audio_blocked(inputs)
	if (locale === "es") return es_video_audio_blocked(inputs)
	if (locale === "pt") return pt_video_audio_blocked(inputs)
	if (locale === "id") return id_video_audio_blocked(inputs)
	if (locale === "fr") return fr_video_audio_blocked(inputs)
	if (locale === "tl") return tl_video_audio_blocked(inputs)
	if (locale === "vi") return vi_video_audio_blocked(inputs)
	if (locale === "ko") return ko_video_audio_blocked(inputs)
	if (locale === "de") return de_video_audio_blocked(inputs)
	if (locale === "ru") return ru_video_audio_blocked(inputs)
	if (locale === "tr") return tr_video_audio_blocked(inputs)
	if (locale === "it") return it_video_audio_blocked(inputs)
	if (locale === "pl") return pl_video_audio_blocked(inputs)
	if (locale === "uk") return uk_video_audio_blocked(inputs)
	if (locale === "hi") return hi_video_audio_blocked(inputs)
	if (locale === "ar") return ar_video_audio_blocked(inputs)
	if (locale === "ms") return ms_video_audio_blocked(inputs)
	if (locale === "bn") return bn_video_audio_blocked(inputs)
	if (locale === "zh-TW") return zh_tw2_video_audio_blocked(inputs)
	if (locale === "zh-HK") return zh_hk2_video_audio_blocked(inputs)
	if (locale === "ur") return ur_video_audio_blocked(inputs)
	if (locale === "fa") return fa_video_audio_blocked(inputs)
	if (locale === "sw") return sw_video_audio_blocked(inputs)
	if (locale === "nl") return nl_video_audio_blocked(inputs)
	return en_video_audio_blocked(inputs)
});